export default "__VITE_ASSET__BYlfWVmU__"